import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientDataForAppoinment } from '../service/make-appoinment.model';
import { MakeAppointmentService } from '../service/make-appointment.service';
import { SharedService } from 'src/app/services/shared.service';
import { ApiService } from 'src/app/services/api.service';
import { MRIType, ToastType } from 'src/app/enums/enums';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-mriappointment',
  templateUrl: './mriappointment.component.html',
  styleUrls: ['./mriappointment.component.scss']
})
export class MRIAppointmentComponent {
  MRIAppoinmentForm: FormGroup;
  @Input() patientData: PatientDataForAppoinment = {
    id: 0,
    name: '',
    caseName: '',
    da: '',
    de: '',
    clinicId: 0,
    isDischarged: false
  };
  isData = false;
  activeModal = inject(NgbActiveModal);
  currentDate = new Date();
  facilities: any = [];
  mriTypes: { key: number; value: string }[] = [];

  constructor(private makeAppointmentService: MakeAppointmentService, private sharedService: SharedService, private apiService: ApiService, private toast: ToastService) {
    this.MRIAppoinmentForm = new FormGroup({
      noCervicalMRI: new FormControl(false),
      cmriFacilityId: new FormControl(false),
      cSchedDate: new FormControl(null),
      cScanDone: new FormControl(false),
      noThoracicMRI: new FormControl(false),
      tmriFacilityId: new FormControl(null),
      tSchedDate: new FormControl(null),
      tScanDone: new FormControl(false),
      noLumbarMRI: new FormControl(false),
      lmriFacilityId: new FormControl(null),
      lSchedDate: new FormControl(null),
      lScanDone: new FormControl(false),
      noExtremityMRI: new FormControl(false),
      omriType1: new FormControl(null),
      omriFacilityId1: new FormControl(null),
      omriSchedDate1: new FormControl(null),
      oScanDone1: new FormControl(false),
      omriType2: new FormControl(null),
      omriFacilityId2: new FormControl(null),
      omriSchedDate2: new FormControl(null),
      oScanDone2: new FormControl(false),
      omriType3: new FormControl(null),
      omriFacilityId3: new FormControl(null),
      omriSchedDate3: new FormControl(null),
      oScanDone3: new FormControl(false),
      omriType4: new FormControl(null),
      omriFacilityId4: new FormControl(null),
      omriSchedDate4: new FormControl(null),
      oScanDone4: new FormControl(false)
    });
    this.mriTypes = Object.keys(MRIType)
      .filter((key) => !isNaN(Number(key)))
      .map((key) => ({
        key: Number(key),
        value: MRIType[Number(key)]
      }));
    this.currentDate.setHours(0, 0, 0, 0);
  }

  ngOnInit() {
    const fieldsToWatch = [
      'cSchedDate',
      'cScanDone',
      'lSchedDate',
      'lScanDone',
      'omriSchedDate1',
      'oScanDone1',
      'omriSchedDate2',
      'oScanDone2',
      'omriSchedDate3',
      'oScanDone3',
      'omriSchedDate4',
      'oScanDone4'
    ];
    fieldsToWatch.forEach((fieldName) => {
      this.MRIAppoinmentForm.get(fieldName)?.valueChanges.subscribe((value) => {
        switch (fieldName) {
          case 'cSchedDate':
          case 'cScanDone':
            this.checkDate('cSchedDateDiv', 'cScanDone', 'cSchedDate');
            break;
          case 'lSchedDate':
          case 'lScanDone':
            this.checkDate('lSchedDateDiv', 'lScanDone', 'lSchedDate');
            break;
          case 'tSchedDate':
          case 'tScanDone':
            this.checkDate('tSchedDateDiv', 'tScanDone', 'tSchedDate');
            break;
          case 'omriSchedDate1':
          case 'oScanDone1':
            this.checkDate('omriSchedDate1Div', 'oScanDone1', 'omriSchedDate1');
            break;
          case 'omriSchedDate2':
          case 'oScanDone2':
            this.checkDate('omriSchedDate2Div', 'oScanDone2', 'omriSchedDate2');
            break;
          case 'omriSchedDate3':
          case 'oScanDone3':
            this.checkDate('omriSchedDate3Div', 'oScanDone3', 'omriSchedDate3');
            break;
          case 'omriSchedDate4':
          case 'oScanDone4':
            this.checkDate('omriSchedDate4Div', 'oScanDone4', 'omriSchedDate4');
            break;
        }
      });
    });
    this.apiService.GetMRIFacilities(this.patientData.clinicId).subscribe((result) => (this.facilities = result.result));
    this.getMRIAppoinment(this.patientData.id);
  }

  getMRIAppoinment(id: number) {
    this.makeAppointmentService.getMRIAppoinment(id).subscribe({
      next: (res) => {
        this.isData = true;
        const data = this.sharedService.changeDateToString(res.result);
        const { id, patientId, clinicId, cReportNote, lReportNote, oReportNote1, oReportNote2, oReportNote3, ...rest } = data;
        this.MRIAppoinmentForm.setValue(rest);
      },
      error: (error) => {
        console.error(error, 'error');
      },
      complete: () => {}
    });
  }

  makeMRIAppoinment() {
    let data = this.MRIAppoinmentForm.value;
    data.patientId = this.patientData.id;
    data.clinicId = this.patientData.clinicId;
    data.omriFacilityId1 = Number(data.omriFacilityId1);
    data.omriFacilityId2 = Number(data.omriFacilityId2);
    data.omriFacilityId3 = Number(data.omriFacilityId3);
    data.omriFacilityId4 = Number(data.omriFacilityId4);
    data.omriType1 = Number(data.omriType1);
    data.omriType2 = Number(data.omriType2);
    data.omriType3 = Number(data.omriType3);
    data.omriType4 = Number(data.omriType4);
    data.cmriFacilityId = Number(data.cmriFacilityId);
    data.lmriFacilityId = Number(data.lmriFacilityId);
    data.tmriFacilityId = Number(data.tmriFacilityId);
    this.makeAppointmentService.makeMRIAppoinment(data).subscribe({
      next: (result) => {
        this.toast.showToast({
          message: 'MRI Appointment created successfully !',
          type: ToastType.Info
        });
      },
      error: (error) => {
        this.toast.showToast({
          message: error.message,
          type: ToastType.Error
        });
      },
      complete: () => {
        this.activeModal.dismiss();
      }
    });
  }

  updateMRIAppointment() {
    console.log(this.MRIAppoinmentForm.get(''));
    let data = this.MRIAppoinmentForm.value;
    data.patientId = this.patientData.id;
    data.clinicId = this.patientData.clinicId;
    data.omriFacilityId1 = Number(data.omriFacilityId1);
    data.omriFacilityId2 = Number(data.omriFacilityId2);
    data.omriFacilityId3 = Number(data.omriFacilityId3);
    data.omriFacilityId4 = Number(data.omriFacilityId4);
    data.omriType1 = Number(data.omriType1);
    data.omriType2 = Number(data.omriType2);
    data.omriType3 = Number(data.omriType3);
    data.omriType4 = Number(data.omriType4);
    data.cmriFacilityId = Number(data.cmriFacilityId);
    data.lmriFacilityId = Number(data.lmriFacilityId);
    data.tmriFacilityId = Number(data.tmriFacilityId);

    const dateFields = ['cSchedDate', 'tSchedDate', 'lSchedDate', 'omriSchedDate1', 'omriSchedDate2', 'omriSchedDate3', 'omriSchedDate4'];
    dateFields.forEach((field) => {
      if (data[field] === '') {
        data[field] = null;
      }
    });

    this.makeAppointmentService.updateMRIAppoinment(data).subscribe({
      next: (result) => {
        this.toast.showToast({
          message: 'MRI Appointment updated successfully !',
          type: ToastType.Info
        });
      },
      error: (error) => {
        this.toast.showToast({
          message: error.message,
          type: ToastType.Error
        });
      },
      complete: () => {
        this.activeModal.dismiss();
      }
    });
  }

  checkDate(div: string, checkbox: string, mainField: string) {
    const myDiv = document.getElementById(div);
    const checkboxValue = this.MRIAppoinmentForm.get(checkbox)?.value;
    const mainFieldValue = this.MRIAppoinmentForm.get(mainField)?.value;
    if (!checkboxValue && this.isData && mainFieldValue) {
      const date2 = new Date(mainFieldValue);
      if (this.currentDate > date2) {
        myDiv?.classList.add('highlight-red');
      } else {
        myDiv?.classList.remove('highlight-red');
      }
    } else {
      myDiv?.classList.remove('highlight-red');
    }
  }
}
